import type { FaireProductEntity } from "../../entity_types/product";

export const p_t8vkcvub5j: FaireProductEntity = {
  token: "p_t8vkcvub5j",
  type: "product",
  name: "✨NEW PRODUCT LINE✨ - Matcha Matches",
  brandToken: "b_1oesixpi34",
  brandName: "Piecework",
  imageUrl:
    "https://cdn.faire.com/fastly/df93e6c8bb4db23165d34cb5533acca9f9c7612c532b465e53d27b4fdbb77633.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a628e76db356133825cb23f9e54f5d1feec5e4e3e3a43b1af0e53cb139e655ed.jpeg",
    "https://cdn.faire.com/fastly/5e5190bbe2c7d57bdc638402d547958938bbffda374731f11df6211160d11a84.webp",
  ],
  priceDollars: 10,
  description:
    'A green so serene it glows.\n\nMatcha Matches are a premium set of matches in a lush, earthy matcha green. Serenity starts with a strike.\n\n\n150 premium lush, earthy green matchsticks\nEach match measuring approx. 3.6"\n*SAFETY MATCHES*\n',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:26.271Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
